const setSpouseName = (data = null) => {
  return {
    type: 'SET_SPOUSENAME',
    data
  }
}

export default {
  setSpouseName,
}
